export default "__VITE_PUBLIC_ASSET__5b947c73__"